import React, { Component } from "react";
import {CircleArrow as ScrollUpButton} from "react-scroll-up-button";

class ScrollUpBtn extends Component {
    state = {};
    render() {
        return (
            <React.Fragment>
                <ScrollUpButton
                    style={{
                        padding: 8,
                        backgroundColor: "#e0e0e0",
                        fill: "#727272",
                        border: 0,
                        outline: 0,
                        zIndex: 9999
                    }}
                />
            </React.Fragment>
        );
    }
}

export default ScrollUpBtn;
